<template>
    <div class="w-8"></div>
    <div class="ds-exchange-row-text ds-exchange-col-date">
        <div>{{ date }}</div>
        <div class="ds-exchange-row-secondary">{{ startTime }} - {{ endTime }}</div>
    </div>
    <div class="ds-exchange-row-text ds-exchange-col-position cursor-pointer relative" @click="emit('edit')">
        <icon v-if="isFire" class="text-darkred absolute -left-7 -top-1"><IconFire /></icon> 
        {{ position }}
    </div>
    <div class="ds-exchange-row-text ds-exchange-col-department cursor-pointer" @click="emit('edit')">
        {{ department }}
    </div>
    <div class="ds-exchange-col-status">
       <VacancyStatus :status />
    </div>
    <div class="relative ds-exchange-col-employee">
        <div v-if="assigned">
            <User :first-name="assigned.first_name" :last-name="assigned.last_name" :avatar="assigned.avatar" :subtitle="assigned.position?.name" exchange />
        </div>
        <div v-else-if="!responded.length" class="ds-exchange-row-text pl-3">Нет откликов</div>
        <div v-else-if="responded.length === 1" class="flex group">
            <VacancyRespondedUser :user="responded[0]" :vacancy-id="vacancy.id" />
            <Tooltip class="w-64 text-gray left-0 top-10">
                <div class="mb-1">{{ responded[0].position.name }}</div>
                <div class="mb-1">{{ responded[0].department.name }}</div>
                <div class="mb-1">{{ responded[0].department.address }}</div>
            </Tooltip>
        </div>
        <div v-else @click="openRespondedList" class="ds-exchange-card-action ds-exchange-assign-button pl-3"><span class="ds-exchange-assign-plus">+</span>Есть отклики ({{ responded.length }})</div>
        <VacancyRespondedList class="absolute" :list="responded" :vacancy-id="vacancy.id" v-if="showRespondedList" v-click-outside = "closeRespondedList" /> 
    </div>
    
</template>

<script setup lang="ts">
interface Props {
    vacancy: any,

}
import { computed, ref } from 'vue'
import dayjs from 'dayjs'
import User from '../User.vue';
import VacancyRespondedList from './VacancyRespondedList.vue';
import VacancyStatus from './VacancyStatus.vue';
import VacancyRespondedUser from './VacancyRespondedUser.vue';
import Tooltip from './Tooltip.vue';
import IconFire from '@/ui/icons/IconFire.vue';
const { vacancy } = defineProps<Props>()
const emit = defineEmits(['user', 'edit'])

const showRespondedList = ref(false)

const date = computed(() => dayjs(vacancy.dttm_work_start_at).format('DD.MM.YYYY'))
const startTime = computed(() => dayjs(vacancy.dttm_work_start_at).format('HH:mm'))
const endTime = computed(() => dayjs(vacancy.dttm_work_end_at).format('HH:mm'))
const position = computed(() => vacancy.position.name)
const department = computed(() => vacancy.department.name)
const responded = computed(() => vacancy.responded_users)
const assigned = computed(() => vacancy.assigned_user)
const status = computed(() => vacancy.status)
const isFire = computed(() => {
    const now = dayjs();
    const targetTime = dayjs(vacancy.dttm_work_start_at);
    const diffInSeconds = targetTime.diff(now, 'second');
    // Проверяем: время в будущем И разница меньше 24 часов (86 400 секунд)
    return  diffInSeconds > 0 && diffInSeconds < 86400;
})

const openRespondedList = () => {
    showRespondedList.value = true
}

const closeRespondedList = () => {
    showRespondedList.value = false
}

</script>
